<template>
  <div>
    <search-bar></search-bar>
    <div class="wrapper">
      <long-term-locations-table></long-term-locations-table>
      <locations-asking></locations-asking>
    </div>
  </div>
</template>

<script type="text/babel">
  import SearchBar from '../../components/LongTermLocationsList/SearchBar'
  import LongTermLocationsTable from '../../components/LongTermLocationsList/LongTermLocationsTable'
  import LocationsAsking from '../../components/LongTermLocationsList/LocationsAsking'
  export default {
    name: "LongTermLocationsList",
    components: {
      SearchBar,
      LongTermLocationsTable,
      LocationsAsking
    }
  }
</script>

<style lang="scss" scoped>
  .wrapper {
    display:flex;
  }
</style>



// WEBPACK FOOTER //
// client/views/LongTermLocations/LongTermLocationsList.vue